import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { HashRouter as Router, Switch } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { MuiThemeProvider } from '@zn-material-ui'
// import VConsole from '@common/sdk/vconsole.min'
import {
  withSnackbar,
  withSnackbarProps,
  OptionsObject,
  VariantType,
} from 'notistack'
import { observer, inject } from 'mobx-react'
import ScrollTop from '@common/Scrolltop'
import { Common } from '@services/api'
import { IUserStore } from '@stores/UserStore'
import { IAppStore } from '@stores/AppStore'
import Loading from '@components/Loading'
import ConfirmDialog, { IProps as IModalProps } from '@components/Dialog'
import { getHashRoute } from '@utils/url'
import { RouteConfig } from 'react-router-config'
import { IRouteInterface } from '@src/routes/interface'
import moment from 'moment'
import { IntlProvider } from 'react-intl'
import messages from '@common/languageProvider'
import stores from '@stores'
import SwitchLanguage from '@components/SwitchLanguage'
import { transform } from '@utils/intl_lang'
import { defaultRoutes, horizontalRoutes } from '../routes/index'

import '@common/styles/normalize.css'
import '@common/styles/common.css'
import 'swiper/css/swiper.min.css'
import '@common/styles/dropDown.less'

const defaultOptions = {
  variant: 'warning' as VariantType,
  autoHideDuration: 2000,
}

const defaultInfoOptions = {
  variant: 'info' as VariantType,
  autoHideDuration: 2000,
}

interface IProps extends withSnackbarProps {
  UserStore: IUserStore
  AppStore: IAppStore
  routes: any
  customRoute: any
  themeRoutes: RouteConfig[]
}

interface IState {
  loading: boolean
}

// const ua = navigator.userAgent.toUpperCase()
// if (ua.includes('WXWORK') && new Date().getMinutes() === 0) {
//   // @ts-ignore
//   const vConsole = new VConsole()
// }

@inject('UserStore', 'AppStore')
@observer
class App extends React.PureComponent<IProps, IState> {
  public state = {
    loading: false,
  }

  public componentDidMount () {
    const { browserLanguage, MomentMes } = stores.IntlCommon
    moment.locale(MomentMes[browserLanguage])
    this.getTimeGap()
    this.initGlobalUIFunc()
  }


  public render() {
    const { browserLanguage } = stores.IntlCommon
    const { AppStore } = this.props
    // 添加主题色
    const themeColor = AppStore.theme?.styleTheme?.palette?.primary?.main
    const dom = document.body
    dom.style.setProperty('--theme-color', themeColor)
    return (
      <>
        <IntlProvider
          locale={browserLanguage === 'tw' ? 'zh' : browserLanguage}
          messages={messages[browserLanguage]}
        >
          <div style={{ height: 0, overflow: 'hidden' }}>
            <SwitchLanguage />
          </div>
          <div style={{ height: 0, overflow: 'hidden' }}>
            {transform('home')}
          </div>
          <Router>
            <ScrollTop>
              <MuiThemeProvider theme={AppStore.theme.styleTheme}>
                <Switch>{this.renderRoutes(AppStore.theme.id === 'default' ? defaultRoutes : horizontalRoutes)}</Switch>
                {(this.state.loading && <Loading />) || null}
              </MuiThemeProvider>
              <a
                href=""
                id="hiddenLink"
                style={{ display: 'none' }}
                target="_blank"
              />
            </ScrollTop>
          </Router>
        </IntlProvider>
      </>
    )
  }

  private initGlobalUIFunc = () => {
    global.$message = (
      message: string | React.ReactNode,
      options?: OptionsObject
    ) => this.props.enqueueSnackbar!(message, { ...defaultOptions, ...options })
    global.$info = (
      message: string | React.ReactNode,
      options?: OptionsObject
    ) =>
      this.props.enqueueSnackbar!(message, {
        ...defaultInfoOptions,
        ...options,
      })
    global.$showLoading = (visible: boolean) => {
      this.setState({ loading: visible })
      global.$loading = visible
    }
    global.$loading = false
    global.$confirm = this.renderConfirm
  }

  private renderRoutes = (themeRoutes) => {
    const { customRoute, routes } = this.props
    const customRKey = Object.keys(customRoute)
    const themeRouteArr = themeRoutes.reduce(
      (list: RouteConfig[], l: IRouteInterface) => {
        const key = l.path
        if (key && customRKey.includes(key)) {
          return [
            ...list,
            { ...l, children: [...(l.children || []), ...customRoute[key]] },
          ]
        }
        return [...list, l]
      },
      []
    ) as RouteConfig[]

    return renderRoutes([...routes, ...themeRouteArr])
  }

  private renderConfirm = (props: IModalProps) => {
    let modalRoot = document.getElementById(
      'root-modal'
    ) as HTMLDivElement | null

    if (modalRoot) {
      modalRoot.remove()
    }
    modalRoot = document.createElement('div')
    modalRoot.id = 'root-modal'

    const { AppStore } = this.props
    const root = document.getElementById('root') as HTMLDivElement | null

    if (root) {
      root.appendChild(modalRoot)
    }

    ReactDOM.render(
      <IntlProvider
        locale={
          stores.IntlCommon.browserLanguage === 'tw'
            ? 'zh'
            : stores.IntlCommon.browserLanguage
        }
        messages={messages[stores.IntlCommon.browserLanguage]}
      >
        <div style={{ height: 0, overflow: 'hidden' }}>
          <SwitchLanguage />
        </div>
        <MuiThemeProvider theme={AppStore.theme.styleTheme}>
          <ConfirmDialog {...props} />
        </MuiThemeProvider>
      </IntlProvider>,
      modalRoot
    )
  }

  private isNeedUserInfo = () => {
    const paths = [
      // 注册页面
      'register',
      'bankliveroom',
      'touristlive',
      'replayTips',
      'pcLink',
      'invatationMeeting',
      'cmsLitevideo',
      // 单点登陆页
      'singleLogin'
    ]
    return !paths.includes(getHashRoute())
  }

  private isNeedHomeList = () => {
    const paths = ['touristlive', 'replayTips', 'singleLogin']
    return !paths.includes(getHashRoute())
  }

  private getTimeGap = async () => {
    const { AppStore, UserStore } = this.props
    const res: any = await Common.getGlobalTimestamp()
    const timeStamp = res.body.timestamp
    const timeGap = isNaN(Date.now() - timeStamp) ? 0 : (Date.now() - timeStamp)
    await AppStore.setTimeGap(timeGap)
    // 个性化登录接口，解决同步请求导致未取到timeStamp值，headerMap对应值null的问题
    // 获取首页列表，切换横竖版首页/主题
    // 口令直播没有bar

    // 可从isNeedHomeList配置是否需要请求getHomeList接口
    // 以上页面可无需调用
    if (this.isNeedHomeList() && UserStore.getSid()) {
      await AppStore.getHomeList()
    }
    // 获取个性化登录信息
    AppStore.getCustomLoginInfo()
    // 可从isNeedUserInfo配置是否需要请求loadLoginInfo接口
    // 单点登陆页面禁用，防止提示未登陆 2021-11-05 彭子强
    if (this.isNeedUserInfo() && UserStore.getSid()) {
      await UserStore.loadLoginInfo()
    }
    window.addEventListener('hashchange', () => {
      const hashRoute = getHashRoute()
      if (hashRoute === '' || hashRoute.startsWith('login')) {
        console.log('登录态恢复')
        UserStore.loadLoginInfo()
        AppStore.getCustomLoginInfo()
      }
    })
  }
}

export default withSnackbar(App)
